import { render, staticRenderFns } from "./top-banner.vue?vue&type=template&id=7cbc5a28&scoped=true"
import script from "./top-banner.vue?vue&type=script&setup=true&lang=ts"
export * from "./top-banner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./top-banner.vue?vue&type=style&index=0&id=7cbc5a28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbc5a28",
  null
  
)

export default component.exports